export const MAIN_CLASS_NAME = 'status-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const BLOCK_CLASS_NAME = `${CONTENT_CLASS_NAME}__block`;
export const MESSAGE_CLASS_NAME = `${BLOCK_CLASS_NAME}_message`;
export const DETAILS_CLASS_NAME = `${BLOCK_CLASS_NAME}_details`;
export const TITLE_CLASS_NAME = `${BLOCK_CLASS_NAME}__title`;
